import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import initTranslations from './common/services/translations/initTranslations';

let resources = {};

initTranslations().then((res) => {
  resources = res.en.translation;
});

i18n.use(initReactI18next).init({
  partialBundledLanguages: true,
  ns: [],
  resources: {},
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
